import React from "react"
import {
  OrderDetails,
  useOrderLazyQuery,
} from "../../../../api/backend/backend-api"
import Loader from "../../../../ui/atoms/Loader"
import { EditorialLabel } from "../../../contents"
import { useLanguageId } from "../../../localization/hooks"
import { toConfirmedOrder } from "../../converters/order"
import OrderDetailsPanelContent from "../OrderDetailsPanelContent"

interface Props {
  orderId?: string
}

const OrderDetailsPanel = ({ orderId }: Props) => {
  const languageId = useLanguageId()
  const [getOrder, { data, called, loading }] = useOrderLazyQuery({
    fetchPolicy: "no-cache",
  })

  React.useEffect(() => {
    if (orderId) {
      getOrder({
        variables: {
          id: orderId,
          languageId,
        },
      })
    }
  }, [orderId])

  return (
    <div>
      {loading && <Loader className="my-16" />}
      {called && !loading && (
        <>
          {data?.order ? (
            <OrderDetailsPanelContent
              order={toConfirmedOrder(data.order as OrderDetails)}
            />
          ) : (
            <EditorialLabel
              className="text-center"
              scope="orders"
              id="order-not-found"
              variant="subtitle1"
            />
          )}
        </>
      )}
    </div>
  )
}

export default OrderDetailsPanel
